<mat-toolbar class="main-toolbar">
  <img class="img" src="pmi-logo.png" alt="logo" routerLink='/dashboard' routerLinkActive="active" />
  <div class="logo-section">
    <div class="welcome-section main-welcome-section">
      <div class="welcome-text">
        Data Auto Classification Advisor (DACA)<br />
        <span class="date-display">
          <div><span class="fw-bold">NODE:</span> {{selectedNode}}</div>
          <div><span class="fw-bold">ENVIRONMENT:</span> {{selectedEnv}}</div>
        </span>
      </div>
    </div>
  </div>
  <div class="spacer-section"></div>
  <span class="example-spacer"></span>
  <div class="welcome-section user-welcome-section">
    <div class="user-name">Welcome {{ presentUser }}</div>
    <div class="date-display">{{user_role}}</div>
    <div class="date-display">{{currentdate}}</div>
  </div>
  <div class="toolbar-actions">
    <button mat-icon-button class="logout-btn logout-btn-styled" matTooltip="Logout" (click)="logout()">
      <i class="fa-solid fa-arrow-right-from-bracket"></i>
    </button>
  </div>
</mat-toolbar>